// extracted by mini-css-extract-plugin
module.exports = {"container":"SimpleSlider_container__1Je7k","questionWrapper":"SimpleSlider_questionWrapper__1QJSY"};